import client from '@/services/client'
import type { IInputType } from '@/types/flow/FlowPayloadTypes'

import type { AxiosResponse } from 'axios'

export type IntegrationValue = string | boolean | number | null

export interface IIntegrationInputs {
  type: IInputType
  requiresValue: boolean
}

export interface IIntegration {
  integrationCode: string
  name: string
  description?: string
  values?: IntegrationValue[]
  allowedInputTypes: IIntegrationInputs[]
  isUsed: boolean
  defaults: Defaults
}

export interface IIntegrationConfiguration {
  integrationType: 'none' | 'B2B'
}

export interface Defaults {
  unit?: string
  value?: string
  min?: number
  max?: number
  step?: number
}

const getIntegrationParameters = async (
  flowUuid: string
): Promise<AxiosResponse<IIntegration[]>> => {
  return await client.get<IIntegration[]>(
    `flows/${flowUuid}/integration-params`
  )
}

const findIntegrationParams = async (
  flowUuid: string,
  integrationCode: string
): Promise<AxiosResponse<IIntegration>> => {
  return await client.get<IIntegration>(
    `flows/${flowUuid}/integration-params/${integrationCode}`
  )
}

const getConfigurationConfig = async (): Promise<
  AxiosResponse<IIntegrationConfiguration>
> => {
  return await client.get<IIntegrationConfiguration>(`flows/config`)
}

export const IntegrationRepository = {
  getConfigurationConfig,
  getIntegrationParameters,
  findIntegrationParams,
}
